import type { Story } from "@repo/fika-shared/src/loader/story-schema.js"
import { useNavigate, useParams } from "@solidjs/router"
import { createEffect, createMemo, Show } from "solid-js"
import { useAppContext } from "@/context/app"
import { splitUrl } from "@/lib/slug"
import { createStoriesRouter } from "@/routes/stories-router"
import { Frame } from "./frame"

export function StoryItem() {
  const { db } = useAppContext()
  const navigate = useNavigate()
  const params = useParams()
  const getStory = createMemo(() => db.story.get(splitUrl(params.storyId)))
  const { paths } = createStoriesRouter()

  // Redirect if the story is not found
  createEffect<Story | null>(prev => {
    if (!params.storyId) return null

    const story = getStory()
    if (story) return story

    // TODO: why? the id should match!
    // edge case: we created a story optimistically,
    // and we receive the existing one from the backend
    // which does not match the id
    if (prev) {
      const newStory = db.story.findBy({ url: prev.url })
      if (newStory) {
        navigate(paths().story(newStory).url)
        return newStory
      }
    }

    navigate(paths().url)
    return null
  }, null)

  return <Show when={getStory()}>{story => <Frame story={story()} />}</Show>
}
